import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import logo from '../../assets/logo.jpg';
import './LoginGate.css';

export default function LoginGate({ onClose }) {
  const { login, data, isVisitorMode } = useApp();
  const [role, setRole]         = useState('admin');
  const [workerId, setWorkerId] = useState('');
  const [pwd, setPwd]           = useState('');
  const [error, setError]       = useState('');

  if (isVisitorMode) return null;

  function handleLogin(e) {
    e.preventDefault();
    setError('');
    const wid = role === 'worker' ? Number(workerId) : null;
    if (role === 'worker' && !workerId) { setError('Veuillez sélectionner votre nom.'); return; }
    const ok = login(role, pwd, wid);
    if (!ok) { setError('Code incorrect. Réessayez.'); setPwd(''); }
  }

  return (
    <div className="login-overlay" onClick={e => { if (e.target.classList.contains('login-overlay')) onClose?.(); }}>
      <div className="login-box">
        {/* Bouton fermer */}
        {onClose && (
          <button className="login-close" onClick={onClose} title="Fermer">✕</button>
        )}

        <img src={logo} alt="Logo" className="login-logo" />
        <div className="login-brand">KOTOSTECHNOLOGY</div>
        <div className="login-sub">Espace Privé — Connexion</div>

        {/* Role selector */}
        <div className="login-roles">
          <button
            type="button"
            className={`role-btn ${role === 'admin' ? 'active' : ''}`}
            onClick={() => { setRole('admin'); setError(''); }}
          >
            <span className="ri">👑</span>Administrateur
          </button>
          <button
            type="button"
            className={`role-btn ${role === 'worker' ? 'active' : ''}`}
            onClick={() => { setRole('worker'); setError(''); }}
          >
            <span className="ri">👷</span>Ouvrier / Manager
          </button>
        </div>

        <form onSubmit={handleLogin}>
          {role === 'worker' && (
            <select
              value={workerId}
              onChange={e => setWorkerId(e.target.value)}
              className="login-select"
            >
              <option value="">— Sélectionner votre nom —</option>
              {data.workers.map(w => (
                <option key={w.id} value={w.id}>{w.name} ({w.role})</option>
              ))}
            </select>
          )}

          <input
            className="login-input"
            type="password"
            placeholder="Entrez votre code d'accès"
            value={pwd}
            onChange={e => setPwd(e.target.value)}
            maxLength={20}
            autoFocus
          />

          {error && <p className="login-error">{error}</p>}

          <button type="submit" className="btn btn-blue btn-w">
            🔓 Accéder à la plateforme
          </button>
        </form>

        <p className="login-forgot">Code oublié ? Contacter l'administrateur</p>
      </div>
    </div>
  );
}
